import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";
import { api } from "../lib/api";

export default function CTASection({ seamless = false }) {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${api}/subscribe`, { email });
      toast.success(t.cta.success);
      setEmail("");
    } catch (err) {
      toast.error(t.cta.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className={`relative py-24 sm:py-32 overflow-hidden ${
        seamless ? "" : "bg-deepblack grain"
      }`}
    >
      {!seamless && (
        <div className="absolute inset-0 gold-glow pointer-events-none" />
      )}
      <div className="relative max-w-3xl mx-auto px-6 sm:px-8 text-center">
        <Reveal>
          <Overline>{t.cta.overline}</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold mt-4 leading-tight">
            {t.cta.titleA} <span className="text-gold-gradient">{t.cta.accent}</span>
          </h2>
          <p className="mt-5 text-muted2 max-w-xl mx-auto">{t.cta.body}</p>

          <form
            onSubmit={submit}
            data-testid="cta-email-form"
            className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.cta.placeholder}
              data-testid="cta-email-input"
              className="flex-1 bg-navy border border-gold/30 px-5 py-3.5 text-sm text-offwhite placeholder:text-muted2/60 focus:outline-none focus:border-gold transition-colors"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="cta-email-submit"
              className="bg-gold text-deepblack px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-goldhover transition-colors inline-flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? t.cta.sending : t.cta.button}
              {!loading && <ArrowRight size={15} />}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
